import dayjs from "dayjs"
import { IEgresados } from "../interfaces/IEgresados"
import { capitalizeNombresPropios } from "./StringUtils"

export const formatPublicLinkExpiration = (expiraEn: string): string =>
  dayjs(expiraEn).format("DD/MM/YYYY HH:mm")

export const buildQrPublicLinkMessage = (
  egresado: IEgresados,
  url: string,
  _expiraEn: string,
): string => {
  const nombre = `${capitalizeNombresPropios(
    egresado.nombre || "",
  )} ${capitalizeNombresPropios(egresado.apellido || "")}`.trim()

  return `Hola ${nombre}, te dejamos el link para descargar tus QRs:
${url}`
}

export const buildReciboPublicLinkMessage = (
  nombre: string,
  url: string,
  _expiraEn: string,
): string => {
  const saludo = nombre.trim() ? `Hola ${nombre.trim()}` : "Hola"

  return `${saludo}, te dejamos el link para descargar tu recibo:
${url}`
}

export const normalizeWhatsappPhone = (telefono?: string | null): string => {
  const digits = (telefono || "").replace(/\D/g, "")
  if (!digits) return ""

  const withoutInternationalPrefix = digits.startsWith("00")
    ? digits.slice(2)
    : digits
  const normalized = withoutInternationalPrefix.replace(/^0+/, "")

  if (normalized.startsWith("549")) return normalized
  if (normalized.startsWith("54")) {
    const national = normalized.slice(2).replace(/^0+/, "")
    return national.startsWith("9") ? `54${national}` : `549${national}`
  }

  const national = normalized.startsWith("9") ? normalized.slice(1) : normalized

  return `549${national}`
}

export const buildWhatsappUrl = (
  telefono: string | undefined | null,
  message: string,
): string => {
  const phone = normalizeWhatsappPhone(telefono)
  if (!phone) return ""
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
}

export const hasQrTickets = (tarjetasPagadas?: number, tarjetasPagadasMenores?: number): boolean =>
  Number(tarjetasPagadas || 0) + Number(tarjetasPagadasMenores || 0) > 0
